import { DashboardContainer } from '@forwardflow/components/Dashboard'
import MarketingPage from '@forwardflow/components/MarketingAnalytics'

const MarketingAnalytics = () => {
   return (
      <div>
         <DashboardContainer>
            <MarketingPage />
         </DashboardContainer>
      </div>
   )
}

export default MarketingAnalytics
